import ColorService from 'Services/ColorService'
import SizeService from 'Services/SizeService'
import {
  getMemberKeys,
  getUid,
} from 'Services/WeaverUtils'
import { getTypesMap } from './helpers'

const createGroup = (key, createGroupProperties) => {
  const value = createGroupProperties(key)
  return value
}

const createGroupPropertiesForType = (type) => ({
  color: ColorService.getColorForType(type),
})

const createGroupPropertiesForGraph = (graph) => ({
  color: ColorService.getColorForGraph(graph)
})

const createGroupPropertiesForAbstractType = (key) => ({
  color: ColorService.getColorForType(key)
})

const getColorByGraph = (nodes) => {
  const coloredNodes = {}
  _.forEach(nodes, (value, key) => {
    coloredNodes[key] = {
      ...value,
      group: `${value.graph}`
    }
  }, {})

  return { nodes: coloredNodes }
}

const getColorByType = (nodes) => {
  const coloredNodes = {}
  _.forEach(nodes, (value, key) => {
    coloredNodes[key] = {
      ...value,
      group: `${getGroupForType(value.type || value.group)}`
    }
  }, {})

  return { nodes: coloredNodes }
}

const getGroupForType = (types) => {
  let type;
  if (_.isEmpty(types)) {
    return type
  } else if (_.isArray(types)) {
    return getUid(types[0])
  } else {
    return getUid(types)
  }
}

const createGroupForType = (type) => {
  const group = createGroup(type, createGroupPropertiesForType)
  return group
}

const createGroupForGraph = (graph) => {
  const group = createGroup(graph, createGroupPropertiesForGraph)
  return group
}

const createGroupForAbstractType = (type) => {
  const group = createGroup(type, createGroupPropertiesForAbstractType)
  return group
}

const createGroupForRel = (key) => {
  const group = createGroup(key, createGroupPropertiesForAbstractType)
  return group
}

const getGroup = (node) => {
  const colorByGraph = JSON.parse(localStorage.getItem('colorByGraph'))
  if (colorByGraph) {
    return node.getGraph()
  } else {
    const types = getTypes(node)
    return getGroupForType(types[0])
  }
}

const getTypes = (node) => {
  const typesMap = getTypesMap()
  const result = []
  const memberKeys = getMemberKeys()

  if (typesMap[getUid(node)]) {
    result.push(typesMap[getUid(node)])
  }

  memberKeys.forEach((memberKey) => {
    const relations = node.relation(memberKey).all()

    relations.forEach((t) => {
      if (t) {
        const id = getUid(t)
        result.push(typesMap[id])
      }
    })
  })

  return result
}

const buildGraphGroups = async () => {
  const graphs = await Weaver.Graph.list()
  const graphGroups = _.reduce(graphs, (acc, val) => {
    acc[val.id()] = createGroupForGraph(val.id())
    return acc
  }, {})
  const types = getTypesMap()
  const typeGroups = _.reduce(types, (acc, type) => {
    const typeUid = getUid(type.id, type.graph)
    acc[typeUid] = createGroupForType(typeUid)
    return acc
  }, {})
  return { ...graphGroups, ...typeGroups }
}

export {
  getColorByGraph,
  getColorByType,
  getGroupForType,
  getGroup,
  getTypes,
  buildGraphGroups,
  createGroupForType,
  createGroupForGraph,
  createGroupForAbstractType,
  createGroupForRel
}
